import React from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../assets/icons/red-warning.svg";
import "./ConfirmDeleteAvatarModal.less";

export type ConfirmDeleteAvatarModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmDeleteAvatarModal: React.FC<ConfirmDeleteAvatarModalProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onCancel?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="confirm-delete-avatar-overlay" onClick={handleOverlayClick}>
      <div className="confirm-delete-avatar-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="confirm-delete-avatar-container">
          <img src={RedWarningIcon} className="confirm-delete-avatar-icon" alt="Warning" />
          <div className="confirm-delete-avatar-title">{t("delete-avatar")}</div>
          <div className="confirm-delete-avatar-desc">{t("delete-avatar-confirm-message")}</div>
          <button type="button" className="confirm-delete-button" onClick={onConfirm}>
            {t("yes")}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={onCancel}>
            {t("no")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteAvatarModal;
